export default "__VITE_ASSET__DQIqICwX__"